export const ArrowIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='9' height='8' viewBox='0 0 9 8' fill='#0F1521'>
    <path d='M5.79904 6.75C5.22169 7.75 3.77831 7.75 3.20096 6.75L1.0359 3C0.458548 2 1.18024 0.75 2.33494 0.75L6.66507 0.750001C7.81977 0.750001 8.54145 2 7.9641 3L5.79904 6.75Z' stroke='white' />
  </svg>
)
